// FPEL 2025. Pure data — see src/seasons/index.js.
//
// TODO(luke): the archive doc was captured mid-season, so the champion and
// first elimination below are unfilled. Null values render as "TBD" on the
// History page until the real results are entered.
const season2025 = {
  season: 2025,
  leagueId: 175750856,
  label: 'Season 3',
  results: {
    champion: {
      team: 'Captain Jahmyrica',
      manager: 'Mark Phillips',
    },
    runnerUp: "Luke's Only Fans",
    firstOut: { team: "Drunk Mark Sanchez", week: 4 },
  },
   // ISO strings with an explicit Eastern offset so parsing is unambiguous.
  draftDate: '2025-09-02T20:00:00-04:00',
  weekOneKickoff: '2025-09-09T20:15:00-04:00',

  keyDates: [
    { date: 'Sep 2', label: 'Live draft · 8:00 PM ET' },
    { date: 'Sep 9', label: 'Week 1 kickoff' },
    { date: 'TBD', label: 'First elimination week', critical: true },
  ],
};

export default season2025;
